module.exports = __webpack_public_path__ + "static/media/how-it-works-2.e933b065.png";